import React, { useRef } from 'react';

export default function FPOImage({ src, width = 480, height = null, offset = 0, alt = '', isOutlined=false, children = null }) {
   const containerRef = useRef(null);

   const imgStyle = {
    position: 'absolute',
    top: 0,
    left: '0',
    width: '100%',
    transform: `translateX(0) translateY(${offset}px)`,
    pointerEvents: 'none',
  };

  const containerStyle = {
    position: 'relative',
    width: width,
    height: height,
    overflow: 'hidden',
    border: isOutlined ? '1px solid red' : 'none',
  };

  return (
    <div ref={containerRef} style={containerStyle} className="fpo-image-container">
      <img src={src} alt={alt} style={imgStyle} />
      {children}
    </div>
  );
}